import { ApplicantsFiltersStatus } from '~/lib/applicationEnums'

export default {
  section: {
    [ApplicantsFiltersStatus.Favorites]: 'Favoriten',
    [ApplicantsFiltersStatus.New]: 'Neue',
    [ApplicantsFiltersStatus.InterviewArranged]: 'Interview vereinbaren',
    [ApplicantsFiltersStatus.Processing]: 'Bewerbungsprozess',
    [ApplicantsFiltersStatus.OfferSent]: 'Angebot',
    [ApplicantsFiltersStatus.Hired]: 'Eingestellt',
    [ApplicantsFiltersStatus.Rejected]: 'Abgelehnt',
  },
}
